<template lang="pug">
  //- Тот же значок, что у напоминаний по задачам (NotificationTaskReminder)
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Напоминание о заявке
    //- компания или воронка могут быть удалены к моменту отправки — тогда
    //- ссылку построить не из чего и остаётся одно название
    Link(v-if="leadRoute" :to="leadRoute")  {{ item.info.leadTitle }}
    span(v-else)  {{ item.info.leadTitle }}
    template(v-if="item.info.funnelName")
      |  в воронке {{ item.info.funnelName }}
</template>

<script>
export default {
  name: 'NotificationCrmLeadReminder',
  props: {
    item: Object,
    type: String,
  },
  computed: {
    leadRoute() {
      const { companyId, funnelId, leadId } = this.item.info;
      if (!companyId || !funnelId || !leadId) return null;

      return { name: 'crm-lead', params: { companyId, funnelId, leadId } };
    },
  },
};
</script>
